<template>
  <Offcanvas name="userCreateOffcanvas">
    <template v-slot:header>
      <h4>ユーザーの登録</h4>
    </template>
    <template v-slot:default>
      <form @submit.prevent="create">
        <UserForm v-model="newUser" :current-admin-permissions="currentAdmin?.permissions || []"/>
        <div class="mt-3">
          <button class="btn btn-primary w-100">登録</button>
        </div>
      </form>
    </template>
  </Offcanvas>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {createUser} from '../../../api/admin/UserApi';
import {getCurrentAdmin} from '../../../api/admin/AuthApi';
import Offcanvas from '../../../components/Offcanvas.vue';
import useFlashMessage from '../../../composables/useFlashMessage';
import useOffcanvas from '../../../composables/useOffcanvas';
import User from '../../../models/User';
import UserForm from './UserForm.vue';

const emit = defineEmits(['create']);

const {successMessage, errorMessage} = useFlashMessage();
const {closeOffcanvas} = useOffcanvas('userCreateOffcanvas');

const newUser = ref(new User);
const currentAdmin = ref();

onMounted(async () => {
  currentAdmin.value = await getCurrentAdmin();
});

/**
 * ユーザーを登録
 *
 * @returns {Promise<void>}
 */
const create = async () => {
  // Check if current admin still has MANAGE permission
  const freshCurrentAdmin = await getCurrentAdmin();
  const hasManagePermission = freshCurrentAdmin.permissions?.some(p => p.permissionType === 'MANAGE');

  if (!hasManagePermission) {
    errorMessage('管理権限がないためデータを編集できません');
    return;
  }

  try {
    const data = await createUser(newUser.value);
    successMessage('ユーザー「' + data.name + '」を仮登録しました。');
    newUser.value = new User;
    emit('create');
    closeOffcanvas();
  } catch (e) {
    if (e.status === 403) {
      // Do nothing
    } else {
      errorMessage(e.message);
    }
  }
};
</script>
